import { render, staticRenderFns } from "./ElCheckbox.vue?vue&type=template&id=2c315815&scoped=true"
import script from "./ElCheckbox.vue?vue&type=script&lang=js"
export * from "./ElCheckbox.vue?vue&type=script&lang=js"
import style0 from "./ElCheckbox.vue?vue&type=style&index=0&id=2c315815&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2c315815",
  null
  
)

export default component.exports